module.exports = __webpack_public_path__ + "static/5bc8f2692c1e1d332420d75a7234495ba72c62543762e989440e05d0fcc5f9f3-1dfb710af72eeec8e2eaab2a02d81ec9.png";